import { Model } from "./model";

export class Choice extends Model {
    id: number;
    question_id: number;
    label: string;
    is_correct?: number;
    selected?: number;
}


// WEBPACK FOOTER //
// ./src/models/choice.model.ts